import { OfferedLogEntry } from 'lib-shared-legacy-types';
import React from 'react';

import { getLogEntryUserName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationOfferedProps = {
  entry: OfferedLogEntry;
};

export const ConversationOffered = ({
  entry,
}: ConversationOfferedProps): JSX.Element => {
  const text = (
    <>
      Conversation is offered to{' '}
      {entry.agents.map((agent, i) => (
        <React.Fragment key={`conversation-offered-${agent.id}`}>
          <UserLink userId={agent.id}>{getLogEntryUserName(agent)}</UserLink>
          {i !== entry.agents.length - 1 ? ', ' : ' '}
        </React.Fragment>
      ))}
      {entry.queue_label ? `in ${entry.queue_label} queue` : ''}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
